// @ts-check

import { useMemo } from "react";
import { useOfflineDataCachesContext } from '~/components/Offline/OfflineDataCaches';
import SubmissionSyncErrorAlert from '~/components/Offline/Forms/SubmissionSyncErrorAlert';

export default function SubmissionSyncErrorAlertList() {
    const {submissionDrafts: {drafts}, isSyncing} = useOfflineDataCachesContext();

    const draftsWithErrors = useMemo(() => {
        return drafts.filter(draft => draft.$error);
    }, [drafts]);

    if (draftsWithErrors.length === 0 || isSyncing) {
        return null;
    }

    return draftsWithErrors.map(submission => (
        <SubmissionSyncErrorAlert
            key={submission._id}
            submission={submission}
            showTemplate
        />
    ));
}